var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachments = function SvgAttachments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 180.7",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "attachments_svg2__a",
    x1: 11.39,
    x2: 181.3,
    y1: 169.27,
    y2: -0.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M52.19 180.6C23.39 180.6 0 157.3 0 128.41c0-13.9 5.5-27.2 15.3-37l77.09-76.99c2.7-2.7 7-2.7 9.6 0 2.7 2.7 2.7 7 0 9.6L24.9 101.11c-15.4 14.7-16 39.1-1.4 54.59 14.7 15.4 39.1 16 54.59 1.4.5-.4.9-.9 1.4-1.4l99.49-99.49c9.6-9.9 9.3-25.7-.6-35.3-9.7-9.4-25.1-9.4-34.8 0l-80.09 80.2c-4.4 4.4-4.4 11.6 0 16.1 4.4 4.4 11.6 4.4 16.1 0l51.39-51.39c2.6-2.7 6.9-2.8 9.6-.2s2.8 6.9.2 9.6l-.2.2-51.39 51.39c-9.8 9.8-25.6 9.8-35.3 0-9.8-9.8-9.8-25.6 0-35.3l80.19-80.19c15.1-15.1 39.5-15.1 54.59 0 15.1 15.1 15.1 39.5 0 54.59L89.18 165.4c-9.8 9.8-23.1 15.3-36.9 15.3l-.1-.1Z",
    "data-name": "Layer 2",
    style: {
      fill: "url(#attachments_svg2__a)"
    }
  }));
};
export default SvgAttachments;